<ul>
  <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
    <li [attr.data-testid]="child['routerLink']" [ngClass]="{ 'active-menuitem': isActive(i) || this.storedLabel == child['label'] }">
      <a [href]="child.url || '#'" (click)="itemClick($event, child, i)">
        <i class="fa fa-fw" [ngClass]="child.icon"></i>
        <span>{{ child.label }}</span>
        <!--span>{{ JSON.stringify(child) }}</span-->
        <i class="fa fa-fw fa-angle-down" *ngIf="child.items"></i>
      </a>
      <ul app-submenu [item]="child" *ngIf="child.items" [@children]="isActive(i) ? 'visible' : 'hidden'" ></ul>
    </li>
  </ng-template>
</ul>



// WEBPACK FOOTER //
// ./src/app/views/submenu/submenu.html